import React from "react";
import { Link } from "gatsby";
import comics from "../images/misc/comics-featured.png";
import threed from "../images/misc/3d-featured.jpg";


const MiscCategories = () => {
	const categories = [
		{
			id: "comics",
			title: "Comics",
			image: comics,
			slug: "/misc/comics",
		},
		{
			id: "3d",
			title: "3D",
			image: threed,
			slug: "/misc/3d",
		},
	];

	return (
		<div
			style={{
				padding: "3rem 2rem",
				maxWidth: "1200px",
				margin: "0 auto",
			}}
		>

			{/* Category grid */}
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "repeat(2, 1fr)",
					gap: "3rem",
				}}
			>
				{categories.map((category) => (
					<Link
						key={category.id}
						to={category.slug}
						style={{
							textDecoration: "none",
							color: "inherit",
						}}
					>
						<div
							style={{
								cursor: "pointer",
								transition: "all 0.3s ease",
								display: "flex",
								flexDirection: "column",
								gap: "1.5rem",
							}}
							onMouseEnter={(e) => {
								e.currentTarget.style.transform = "translateY(-5px)";
								e.currentTarget.style.opacity = "0.9";
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.transform = "translateY(0)";
								e.currentTarget.style.opacity = "1";
							}}
						>
							{/* Image Container */}
							<div
								style={{
									position: "relative",
									height: "300px",
									overflow: "hidden",
									border: "2px solid #444",
									backgroundColor: "#000",
									borderRadius: "4px",
									transition: "border-color 0.3s ease",
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.borderColor = "#810100";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.borderColor = "#444";
								}}
							>
								<img
									src={category.image}
									alt={category.title}
									style={{
										width: "100%",
										height: "100%",
										objectFit: "cover",
										display: "block",
									}}
									onError={(e) => {
										e.target.style.display = "none";
										if (e.target.nextElementSibling) {
											e.target.nextElementSibling.style.display = "flex";
										}
									}}
								/>
								{/* Fallback placeholder */}
								<div
									style={{
										display: "none",
										alignItems: "center",
										justifyContent: "center",
										width: "100%",
										height: "100%",
										backgroundColor: "#1a1a1a",
										color: "#666",
										fontSize: "0.9rem",
									}}
								>
									{category.title} Image
								</div>
							</div>

							{/* Content */}
							<div>
								<h3
									style={{
										margin: "0 0 0.5rem 0",
										fontSize: "1.5rem",
										fontWeight: "900",
										color: "#863000",
										textTransform: "uppercase",
										letterSpacing: "0.1em",
									}}
								>
									{category.title}
								</h3>
							</div>
						</div>
					</Link>
				))}
			</div>
		</div>
	);
};

export default MiscCategories;
